const Messages = {
    NetWorkError: 'Please check your internet.',

    password_incorrect: 'Your password is incorrect.',
    verify_code_incorrect: 'Invalid verification code provided, please try again.',
    verify_code_expired: 'Verify email code is expired., please try again.',
    username_exist: 'That username is taken. Try another'
}

export default Messages;